import { motion } from "motion/react";

export default function ScrollToTopButton({
                                              primaryColor,
                                              // onClick: z.B. () => scrollToSection(homeRef, "home")
                                              onClick,
                                          }) {
    return (
        <motion.div
            style={{
                position: "fixed",
                bottom: "20px",
                right: "20px",
                zIndex: 100,
                cursor: "pointer",
            }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            onClick={onClick}
        >
            <motion.div
                style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    backgroundColor: primaryColor,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                }}
                animate={{ y: [0, -5, 0] }}
                transition={{ repeat: Infinity, duration: 2 }}
            >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M18 15L12 9L6 15"
                        stroke="#fff"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </motion.div>
        </motion.div>
    );
}
